
function CashControlComp() {
  return (
    <div>CashControlComp</div>
  )
}

export default CashControlComp